/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type unit_option_availability_full = {
  id: number;
  activator: unit_option_availability_full.activator;
  action: unit_option_availability_full.action;
  army_organisation_id: number | null;
  unit_id: number | null;
  unit_option_id: number | null;
  size_min: number | null;
  use_points: unit_option_availability_full.use_points | null;
  value: number | null;
};
export namespace unit_option_availability_full {
  export enum activator {
    SAME_UNIT = 'SameUnit',
    OTHER_UNIT = 'OtherUnit',
    ARMY_ORGANISATION = 'ArmyOrganisation',
    SIZE_MIN = 'SizeMin',
  }
  export enum action {
    ENABLE = 'Enable',
    DISABLE = 'Disable',
    CHANGE_POINTS = 'ChangePoints',
    AUTO_SELECT = 'AutoSelect',
    CHANGE_CHOISE_LIMIT = 'ChangeChoiseLimit',
    CHANGE_ENCHANTMENT_LIMIT = 'ChangeEnchantmentLimit',
  }
  export enum use_points {
    COST = 'Cost',
    NO_COST = 'NoCost',
    FREE = 'Free',
    NO_LIMIT = 'NoLimit',
    UP_TO = 'UpTo',
  }
}
